import { t } from 'i18next'
import React from 'react'

const SocialMediaLinks = () => {
    return (
        <>
            <div className="col-md-6 text-end">
                <ul className="social-links">
                    <li>
                        <label>{t("follow_us")}</label>
                    </li>
                    <li>
                        <a href="https://m.facebook.com/connecthomesegy/" target="_blank">
                            <i className="fa-brands fa-facebook-f"></i>
                        </a>
                    </li>
                    {/* <li>
                        <a href="#">
                            <i className="fa-brands fa-x-twitter"></i>
                        </a>
                    </li> */}
                    <li>
                        <a href="https://www.instagram.com/connecthomes?igsh=MXdvNDNtYXJhanc=" target="_blank">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://eg.linkedin.com/company/connect-homes" target="_blank">
                            <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default SocialMediaLinks